import ApiService from '@/common/api.service';

const url = '/v1/contacts';

const ContactService = {
  query(filters) {
    let params = {};

    Object.keys(filters)
      .sort()
      .forEach(key => {
        params[key] = filters[key];
      });

    return ApiService.query(url, { params: params });
  },
  get(id) {
    return ApiService.get(url, id);
  },
  delete(id) {
    return ApiService.delete(`${url}/${id}`);
  },
  save(id = null, contact) {
    if (!id) {
      return ApiService.post(url, contact);
    }
    return ApiService.update(url, id, contact);
  },
  search(param) {
    return ApiService.get(url, `search?filter[name]=${param}`);
  }
};

export default ContactService;
